import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Kanaal voor stap-sprong-verzoeken binnen de booking-wizard: een stepper-click of een
 * "wijzig"-knop op de overview vraagt een sprong naar stap N aan. BookingPage luistert op
 * `requests$` en doet reset-from-step + navigate. Er is geen bevestigings-modal meer — een
 * sprong gaat direct.
 */
@Injectable({ providedIn: 'root' })
export class BookingStepNavigationService {
  private readonly _requests$: Subject<number> = new Subject<number>();
  public readonly requests$: Observable<number> = this._requests$.asObservable();

  public request(stepIndex: number): void {
    this._requests$.next(stepIndex);
  }
}
